// Index des articles de spots - Actuellement vide
// import { belvedereAnnecy } from './belvedere-lac-annecy';
// import { montSaintMichelBaie } from './mont-saint-michel-baie';
// import { calanquesSugiton } from './calanques-cassis-sugiton';

// Export de tous les spots sous forme de tableau (vide pour l'instant)
export const spotsArticles = [
  // Les spots seront ajoutés ici prochainement
];

// Fonction utilitaire pour récupérer un spot par slug
export const getSpotBySlug = (slug) => {
  return spotsArticles.find(spot => spot.slug === slug);
};

// Fonction pour récupérer tous les slugs (pour le sitemap)
export const getAllSpotSlugs = () => {
  return spotsArticles.map(spot => spot.slug);
};

// Fonction pour récupérer les spots récents
export const getRecentSpots = (limit = 3) => {
  return spotsArticles
    .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
    .slice(0, limit);
};

// Fonction pour récupérer un spot par ID
export const getSpotById = (id) => {
  return spotsArticles.find(spot => spot.id === id);
};

// Export par défaut pour compatibilité
export default spotsArticles;